<template>
    <div id="discountedDaysList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="bg-white data-table p-0" v-if="from != undefined">
            <div v-show="!makechargeable">
                <data-table-filter-config :moduleName="'DiscountedDaysList'" ref="filterComponent" @cancelSelection="cancelAll"></data-table-filter-config>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'DiscountedDaysList'">
                </custom-pagination>
                <vue-good-table
                    ref="listDiscountedDaysTable"
                    mode="remote"
                    title="Customer"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    @on-select-all="onSelectAll"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        setCurrentPage:listCurrentPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    :select-options="{
                    enabled: true,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    }"
                    :search-options="{
                    enabled: false,
                    }">
                    <div slot="selected-row-actions">
                        <button id="deleteCustomerBtn" v-on:click.prevent="makeNonChargeable" class="btn btn-danger">Make Non Chargeable</button>
                    </div>
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'DiscountedDaysList'">
                </custom-pagination>
            </div>
            <div v-show="makechargeable">
                <h5>Make Non Chargeable</h5>
                <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="RentalAgreementForm">
                    <div class="col-md-6 form-group">
                        <label class="control-label" for="reason">Reason:</label>
                        <v-select v-model="reason" name="reason" placeholder="Select Reason." label="text" :options="reasonArr" class="close-remove"></v-select>
                        <div class="field-error"></div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="control-label" for="reason">Comment:</label>
                        <textarea class="form-control" v-model="comment" id="specification" rows="5" placeholder='Enter "," seperated Specifications' name="specification">
                        </textarea>
                        <div class="field-error"></div>
                    </div>
                    <div class="btn-groups posFixed">
                        <button type="submit" id="CreateDiscountedDaysBtn" class="btn btn-primary" v-on:click.prevent="updateBillingDays">
                        <i class="fp-save"> </i>  Save
                        </button>
                        <button type="submit" id="cancelDiscountedDaysBtn" class="btn btn-tertiary" v-on:click.prevent="makechargeable = false">
                        <i class="fp-close"> </i>  Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>

import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

import { locale } from 'moment';

    export default {
        name: "CustomerList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            from: {
                type: String,
                required: false,
                default:undefined
            },

        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            userColumns:[],
            cantAccessPage: "",
            columns: [
                {
                    label: '# Agreement',
                    field: 'agreement_no',
                    filterable: true,
                    fpFieldType:"text",
                    width:'140px',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterFn: this.onColumnFilter,
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Date',
                    field: 'date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // as per requirement 13/09/2023
                // {
                //     label: 'Day',
                //     field: 'day',
                //     fpFieldType:"text",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Days", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Contract',
                    field: 'contract',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Reason',
                    field: 'reason',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "City", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Comment',
                    field: 'comment',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "State", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Billed',
                    field: 'billed',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes', 'No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            customerStage:"",
            custId:0,
            action:"list",
            makechargeable:false,
            reasonArr:[],
            comment:'',
            reason:'',
            updatedBillingDaysArr:[],
        }),
        metaInfo () {
            return {
                title: "Discounted Days | " +process.env.COPYRIGHT_NAME
            }
        },
        watch:{

            //check permission change
            // permissions: function (permissions) {

            //     var self = this;
            //     if (permissions.length > 0) {
            //         for (var i = 0; i < permissions.length; i++) {
            //             if (permissions[i].name == 'list_customer') {
            //                 self.cantAccessPage = true;
            //             } else if (permissions[i].name == 'delete_customer') {
            //                 self.canDeleteCustomer = true;
            //             } else if (permissions[i].name == 'view_customer') {
            //                 self.canViewCustomer = true;
            //             } else if (permissions[i].name == 'add_customer') {
            //                 self.canUpdateCustomer = true;
            //                 self.canAddCustomer = true;
            //             } else if (permissions[i].name == 'add_customer_contact') {
            //                 self.canAddCustomerContact = true;
            //             }
            //         }
            //     }

            // }

        },
        created: function() {
            this.serverParams.sort = {field:"updated_at",type:"desc"};
        },
        mounted: function() {
            var self = this;
            // self.getPermissions();
            self.fetchReason();
            self.loadList();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listDiscountedDaysTable.unselectAllInternal();
            },
            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },
            makeNonChargeable:function(){
                var self = this;
                self.makechargeable = true;
            },



            loadList() {

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                if(self.customerReportVal == 'registerreport'){
                    self.flag = 'registerreport';
                }

                self.loading = true;
                //get selected customers ids

                var fields = {

                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    id: segments[3],

                };

                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/billing-days/fetch",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {

                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        self.generateStatusCodeMessage(jqXHR,false,'fetch-discounted-days-error')

                    }
                });
            },
            selectionChanged:function(){

            },

            fetchReason: function () {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get_reasons",
                    type: "GET",
                    crossDomain: true,
                    data:{
                        module:'discounted day'
                    },
                    headers: this.ajxHeaders,

                    dataType: "json",
                    success: function (data) {
                        self.reasonArr = data;
                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'get-reason')
                    }
                });
            },

            updateBillingDays:function(){
                var self = this;
                var error = false;
                self.updatedBillingDaysArr = [];
                var data = this.$refs['listDiscountedDaysTable'].selectedRows;
                if (self.reason == null || !self.reason.value){
                    error = true;
                }
                for (var i = 0; i < data.length; i++) {
                    self.updatedBillingDaysArr.push(self.$refs['listDiscountedDaysTable'].selectedRows[i].id)
                }
                if (self.updatedBillingDaysArr && self.updatedBillingDaysArr.length > 0){

                    if (error){
                        self.$swal('','Please select reason before update','info');
                    }else{

                        self.loading = true;

                        $.ajax({
                            url: process.env.ROOT_API + "/discounted-days/update",
                            type: "POST",
                            headers: this.ajxHeaders,
                            dataType: "json",
                            data:{
                                idArr:JSON.stringify(self.updatedBillingDaysArr),
                                reason:self.reason.value,
                                comment:self.comment
                            },
                            success: function (data) {

                                self.loading = false;
                                self.billingLoaded = true;
                                if (data.code == 201){
                                    self.$swal('',data.message,'info');
                                    return;
                                }
                                if (data.status == "success") {
                                    // self.$swal('','Agreement Processed','info');
                                    self.makechargeable = false;
                                    self.loadList();
                                }else{
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.loading = false;
                                if (jqXHR.status == 0) {
                                    self.errorMsg = "Remote server cannot be reached";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("tkn");
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/");
                                    }
                                    self.error = jqXHR.responseJSON.message;
                                }
                            }
                        });
                    }
                }
            },

        }
    };
</script>
<style scoped>
.posFixed{
    position:relative !important;
}
</style>





// WEBPACK FOOTER //
// src/components/DiscountedDaysList.vue